import React, { FC } from 'react';

import Accordion from '@ps-int/ps-components/src/components/accordion';
import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Link } from '..';
import { selectIsFaqModalVisible, setIsFaqModalVisible } from '../../features/settings';
import { i18n } from '../../helpers/i18n';
import { useActions } from '../../hooks';
import I18N from '../i18n';
import ModalWithHeader from '../modal-with-header';
import css from './styles.css';

const getItems = () => [
    {
        title: i18n('faq', 'question-1'),
        description: i18n('faq', 'answer-1'),
    },
    {
        title: i18n('faq', 'question-2'),
        description: (
            <I18N keyset="faq" loc="answer-2">
                <Link
                    className={cn(css.link, css.underlined)}
                    data-ref="link-payment-plans"
                    view="default"
                    href="https://yandex.ru/support/yandex-360/business/purchase/ru/plans/payment-plans"
                    target="_blank"
                />
            </I18N>
        ),
    },
    {
        title: i18n('faq', 'question-3'),
        description: i18n('faq', 'answer-3'),
    },
    {
        title: i18n('faq', 'question-4'),
        description: (
            <I18N keyset="faq" loc="answer-4">
                <Link
                    className={css.link}
                    data-ref="link-business"
                    view="default"
                    href="https://360.yandex.ru/business/"
                    target="_blank"
                />
            </I18N>
        ),
    },
    {
        title: i18n('faq', 'question-5'),
        description: i18n('faq', 'answer-5'),
    },
    {
        title: i18n('faq', 'question-6'),
        description: i18n('faq', 'answer-6'),
    },
];

export const FaqModal: FC = () => {
    const actions = useActions({ setIsFaqModalVisible });
    const isFaqModalVisible = useSelector(selectIsFaqModalVisible);

    const closeModal = () => actions.setIsFaqModalVisible(false);

    return (
        <ScopedTheme theme="dark" force>
            <ModalWithHeader
                className={css.modal}
                onClose={closeModal}
                visible={isFaqModalVisible}
                title={i18n('faq', 'title')}
                scrollable
            >
                <Accordion items={getItems()} />
            </ModalWithHeader>
        </ScopedTheme>
    );
};
